import { render, staticRenderFns } from "./FormTokenInput.vue?vue&type=template&id=0b936721"
import script from "./FormTokenInput.vue?vue&type=script&lang=js"
export * from "./FormTokenInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports